module.exports = __webpack_public_path__ + "static/stijn-8f458aebcd56ba6e7cdb9251ca6f382a.png";